// @flow
export { default } from './Logo';
